/**
 *
 * As the name implies, this function decodes raw text.
 * It converts HTML entities to their corresponding characters.
 *
 * @param rawText
 * @returns {string|string}
 */

const decodeRawText = (rawText) => {
    return new DOMParser().parseFromString(rawText, 'text/html').body.textContent || '';
};

export default decodeRawText;
